import { useMemo } from "react";
import { useFormik } from "formik";
import { Flex, FormControl, FormLabel, Select as ChakraSelect, Input as ChakraInput, Button } from "@chakra-ui/react";
import { PartnersFilter, defaultPartnersFilterFields } from "../_helpers";
import { Recruiter } from "@/model/recruiters";

export interface PartnersPopupFilterProps {
  readonly values: PartnersFilter;
  readonly onApply: (values: PartnersFilter) => void;
  readonly onReset: () => void;
  readonly recruiters: readonly Recruiter[];
  readonly statusOptions: readonly { value: string; label: string }[];
}

export const PartnersPopupFilter = ({ values, onApply, onReset, recruiters, statusOptions }: PartnersPopupFilterProps) => {
  const formik = useFormik<PartnersFilter>({
    initialValues: values,
    enableReinitialize: true,
    onSubmit: (submittedValues: PartnersFilter) => {
      onApply(submittedValues);
    },
  });

  const handleResetLocal = () => {
    formik.resetForm({ values: defaultPartnersFilterFields });
    onReset();
  };

  const handleApplyLocal = () => {
    void formik.submitForm();
  };

  return (
    <>
      <FormControl>
        <FormLabel>Статус</FormLabel>
        <ChakraSelect
          placeholder="Все статусы"
          value={formik.values.status || ""}
          onChange={(e) => {
            formik.setFieldValue("status", e.target.value || undefined);
          }}
        >
          {statusOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </ChakraSelect>
      </FormControl>

      <FormControl>
        <FormLabel>Ответственный</FormLabel>
        <ChakraSelect
          placeholder="Все сотрудники"
          value={formik.values.responsible || ""}
          onChange={(e) => {
            formik.setFieldValue("responsible", e.target.value || undefined);
          }}
        >
          {recruiters.map((r) => (
            <option key={r.id} value={r.username}>
              {r.username}
            </option>
          ))}
        </ChakraSelect>
      </FormControl>

      <FormControl>
        <FormLabel>Дата создания</FormLabel>
        <Flex direction="row" gap="12px">
          <ChakraInput
            type="date"
            value={formik.values.created_at_from || ""}
            onChange={(e) => formik.setFieldValue("created_at_from", e.target.value || undefined)}
          />
          <ChakraInput
            type="date"
            value={formik.values.created_at_to || ""}
            onChange={(e) => formik.setFieldValue("created_at_to", e.target.value || undefined)}
          />
        </Flex>
      </FormControl>
      <Flex justifyContent="flex-end" gap="8px">
        <Button variant="ghost" onClick={handleResetLocal}>
          Сбросить
        </Button>
        <Button onClick={handleApplyLocal} bg="#2563eb" color="white" _hover={{ bg: "#2563eb" }} _active={{ bg: "#2563eb" }}>
          Применить
        </Button>
      </Flex>
    </>
  );
};

